var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralProgramIconNavPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0994 7.91326L13.6827 7.42076C13.4894 7.39659 13.3211 7.27576 13.2319 7.09742L11.7086 4.04742C11.7061 4.04409 11.7044 4.04076 11.7027 4.03659C11.5627 3.77742 11.3452 3.55992 11.0827 3.42076C10.3769 3.06159 9.50108 3.33826 9.12858 4.04742L7.60362 7.09659C7.51362 7.27492 7.34362 7.39659 7.14278 7.42159L3.73362 7.91326C3.40362 7.96242 3.11445 8.10909 2.89945 8.33574C2.63445 8.60991 2.49278 8.97157 2.50028 9.35324C2.50778 9.73491 2.66362 10.0891 2.93695 10.3507L5.40945 12.7307C5.54695 12.8591 5.61112 13.0549 5.57778 13.2457L4.99362 16.5941C4.94362 16.9066 4.99695 17.2291 5.14195 17.4957C5.32362 17.8374 5.62612 18.0866 5.99445 18.1999C6.13362 18.2424 6.27612 18.2632 6.41695 18.2632C6.64862 18.2632 6.87778 18.2066 7.08528 18.0957L10.1352 16.5191C10.3119 16.4249 10.5244 16.4249 10.7052 16.5207L13.7402 18.0907C14.0127 18.2407 14.3236 18.2949 14.6511 18.2449C15.4336 18.1166 15.9694 17.3749 15.8419 16.5874L15.2586 13.2457C15.2244 13.0491 15.2877 12.8566 15.4319 12.7182L17.8969 10.3507C18.1277 10.1282 18.2794 9.83074 18.3211 9.51324C18.4236 8.73657 17.8744 8.01826 17.0994 7.91326Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralProgramIconNavPanel);
export default __webpack_public_path__ + "static/media/referral_program_icon_nav_panel.894a107824b614e8e5f452e4c0129a0a.svg";
export { ForwardRef as ReactComponent };